import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { logUI } from '../../api/andyliticsApi';
import * as Tools from '../../helpers/Tools';
import { useTranslation } from 'react-i18next';
import { LinkText } from "../ecosystem/";
import LoginPageNotifier from "./LoginPageNotifier";

const LoginFormError = ({
    errorLogin,
    serviceError,
    errors,
    loginErrorCode,
    lockedUserError,
    technicalHelpDeskNumber,
    technicalHelpDeskHours,
    myChartRegistrationUrl
}) => {
    const { t } = useTranslation();
    const duplicateError = 'possible duplicate user';
    const fcDuplicateUserError = 'fc duplicate user found';
    const notifierColorStyle = errorLogin &&
        (errorLogin.toLowerCase() === duplicateError || errorLogin.toLowerCase() === fcDuplicateUserError) ? "alert" : "error"

    const getSanitizeError = (errorLogin) => {
        if (errorLogin) {
            if (errorLogin.toLowerCase() === duplicateError) {
                logUI(
                    'MBHWeb.Logon.Client.Duplicate.MYBSWHFC',
                    new Date(),
                    Tools.getURLPath()
                );
                const content =                    
                        <>Your login credentials need to be reconciled by the MyBSWHealth technical help desk. 
                        Call <LinkText
                            typographyType="body-02"
                            href={"tel:" + technicalHelpDeskNumber}
                            underline="always"
                            color="$color-primary-a2"
                        >
                            {technicalHelpDeskNumber}
                        </LinkText> for assistance.
                    </>
                    
                return (
                    content
                );
            } else if (errorLogin.toLowerCase() === fcDuplicateUserError) {
                logUI(
                    'MBHWeb.Logon.Client.Duplicate.FC',
                    new Date(),
                    Tools.getURLPath()
                );
                const registrationUrl =
                    myChartRegistrationUrl + 'verification/sms?option=No';
                const content = <>Your legacy MyFirstCare Self-Service username was claimed by an existing MyBSWHealth portal user.
                    Please click <LinkText
                        typographyType="body-02"
                        href={registrationUrl}
                        underline="always"
                        color="$color-primary-a2"
                    >
                        here
                    </LinkText> to go through the registration process to set up your account with a new username and password.
                </>;
                return (
                    content
                );
            }
        }

        return errorLogin;
    }

    return (
        (errorLogin ||
            serviceError ||
            errors['errorCode'] === 401) &&
            loginErrorCode !== lockedUserError
            ? (
                <LoginPageNotifier
                    colorStyle={notifierColorStyle}
                >
                    {(errorLogin || serviceError) && (
                        <div>
                            {getSanitizeError(errorLogin) || t('Login failed. Please try again later.')}
                        </div>           
                    )}
                    {errors['errorCode'] === 401 && (
                        <div>
                            {t("Your token has expired. Please sign in again.")}
                        </div>                       
                    )}
                </LoginPageNotifier>    
            ) : (
                ''
            )
    );
};

export default LoginFormError;
